import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import HeroCarousel from '../Common/HeroCarousel';
import { FaCheckCircle, FaUsers, FaHandHoldingMedical, FaMicrophone, FaBible, FaArrowRight } from 'react-icons/fa';
import aboutImage1 from '../../Assets/about.png';
import lineImage from '../../Assets/line.png';
import prophetessImage from '../../Assets/Prophetess.png';

const AboutUs = () => {
  return (
    <>
      <Header />
      
      {/* Hero Section */}
      <HeroCarousel 
        title="About Us"
        subtitle="Learn about our story, our core values, our beliefs, our Pastor"
        height="h-96"
        contentPosition="bottom"
      />

      {/* About Our Ministry Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="h-6 w-40 bg-primary mb-8 rounded-full"></div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8">About Our Ministry</h2>
              <div className="space-y-4 text-gray-700 font-sf-pro">
                <p>
                  House of Praise Healing and Prophetic Ministries was founded in 2012 with a vision to create a place where people could experience God's supernatural healing power and prophetic guidance.
                </p>
                <p>
                  What began as a small prayer group of just 12 people meeting in our founder's living room has grown into a vibrant community of believers passionate about experiencing the fullness of God's presence.
                </p>
                <p>
                  Through the years, we've witnessed countless miracles, healings, and lives transformed by the power of faith. Our journey has been marked by divine intervention and a steadfast commitment to creating an atmosphere where the supernatural becomes natural.
                </p>
              </div>
            </div>
            <div className="w-full">
              <img 
                src={aboutImage1} 
                alt="Worship service" 
                className="rounded-lg shadow-lg w-full h-64 md:h-80 lg:h-96 object-cover" 
              />
            </div>
          </div>
        </div>
      </div>

      {/* Community Image Section */}
      <div className="py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24 ">
          <img 
            src={lineImage} 
            alt="Our community" 
            className="w-full h-64 md:h-80 lg:h-96 object-cover rounded-lg shadow-xl"
          />
        </div>
      </div>

      {/* Core Values Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex justify-end mb-8">
            <div className="h-2 w-72 bg-primary rounded-full"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold flex justify-end mb-12">Our Core Values</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Divine Healing */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex justify-center mb-4">
                <div className="bg-blue-200 p-4 rounded-full">
                  <FaHandHoldingMedical className="text-blue-600 text-2xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center mb-3 font-sf-pro">Divine Healing</h3>
              <p className="text-gray-600 text-center text-sm font-sf-pro">
                We believe in God's power for real physical, emotional, and spiritual through prayer and faith. This includes prayer for the sick and testimonies of God's healing power.
              </p>
            </div>

            {/* Prophetic Ministry */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex justify-center mb-4">
                <div className="bg-orange-100 p-4 rounded-full">
                  <FaMicrophone className="text-orange-500 text-2xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center mb-3 font-sf-pro">Prophetic Ministry</h3>
              <p className="text-gray-600 text-center text-sm font-sf-pro">
                We embrace the prophetic gifts, believing God still speaks today through visions, dreams, and words of knowledge. Our prayer meetings, small groups, and services encourage spiritual growth.
              </p>
            </div>

            {/* Authentic Community */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex justify-center mb-4">
                <div className="bg-gray-200 p-4 rounded-full">
                  <FaUsers className="text-gray-600 text-2xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center mb-3 font-sf-pro">Authentic Community</h3>
              <p className="text-gray-600 text-center text-sm font-sf-pro">
                We foster genuine relationships where people can grow together in faith, support one another through life's challenges, and celebrate God's goodness together.
              </p>
            </div>

            {/* Biblical Truth */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex justify-center mb-4">
                <div className="bg-purple-100 p-4 rounded-full">
                  <FaBible className="text-purple-500 text-2xl" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-center mb-3 font-sf-pro">Biblical Truth</h3>
              <p className="text-gray-600 text-center text-sm font-sf-pro">
                We are committed to teaching and living according to the Word of God as our foundation for faith and practice, balanced with the power of the Holy Spirit.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mission Section */}
      <div className="bg-black text-white py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex justify-start mb-8">
            <div className="h-2 w-64 bg-blue-600 rounded-full"></div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Mission</h2>
            </div>
            <div>
              <p className="text-gray-300 font-sf-pro text-right">
                Our mission is to create an atmosphere where people can encounter God's healing presence, receive prophetic direction, and grow in their spiritual journey. We embrace both the compassionate and revelatory aspects of ministry.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Vision Section */}
      <div className="bg-black text-white py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <div className="flex justify-end mb-8">
            <div className="h-2 w-64 bg-blue-600 rounded-full"></div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Vision</h2>
            </div>
            <div>
              <p className="text-gray-300 font-sf-pro text-right italic">
                "Where there is no vision, the people perish: but he that keepeth the law, happy is he." - Proverbs 29:18
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* What We Believe Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          <h2 className="text-4xl md:text-4xl font-bold text-center mb-12">What We Believe</h2>
          
          <div className="bg-blue-100 rounded-lg p-10 shadow-lg">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Left Column */}
              <div className="space-y-8">
                {/* The Authority of Scripture */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">The Authority of Scripture</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">The Bible is the inspired, infallible Word of God and our ultimate authority for faith and practice.</p>
                  </div>
                </div>

                {/* Baptism in the Holy Spirit */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">Baptism in the Holy Spirit</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">The baptism in the Holy Spirit with the evidence of speaking in tongues as the spirit gives utterance.</p>
                  </div>
                </div>

                {/* Salvation by Grace */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">Salvation by Grace</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">Salvation is through faith in Jesus Christ alone, not by works, but by God's grace and mercy.</p>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="space-y-8">
                {/* Divine Healing */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">Divine Healing</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">Divine Healing is provided in the atonement and is available to all believers through prayer and faith.</p>
                  </div>
                </div>

                {/* Gifts of the Spirit */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">Gifts of the Spirit</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">The gifts of the spirit are active today and available to all believers for the edification of the church.</p>
                  </div>
                </div>

                {/* Second Coming */}
                <div className="flex items-start">
                  <div className="flex-shrink-0 mr-4">
                    <FaCheckCircle className="text-blue-600 text-xl" />
                  </div>
                  <div>
                    <h3 className="font-bold mb-4 font-sf-pro">Second Coming</h3>
                    <p className="text-gray-700 text-sm font-sf-pro">The personal, imminent and pre-millennial second coming of Jesus Christ.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Meet Our Prophetess Section */}
      <div className="bg-gray-100 py-16">
        <div className="container mx-auto px-6 md:px-12 lg:px-24">
          
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
                <div className="flex justify-start mb-8">
                    <div className="h-4 w-96 bg-primary rounded-full"></div>
                </div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8">Meet Our Prophetess</h2>
              <div className="bg-gray-50 p-8 rounded-lg shadow-md">
                <h3 className="text-2xl font-bold mb-1 font-sf-pro">Prophetess Tina James</h3>
                <p className="text-purple-600 font-medium mb-4 font-sf-pro">Senior Pastor & Founder</p>
                <p className="text-gray-700 mb-6 font-sf-pro">
                  With over 13 years in ministry, Prophetess Tina carries a powerful annointing for healing and prophetic ministry. She has witnessed thousands of miraculous healings and has trained hundreds in operating in the gifts of the spirit. Her heart is to see every believer walking in their God-given destiny.
                </p>
              </div>
            </div>
            <div>
              <img src={prophetessImage} alt="Prophetess Tina James" className="rounded-lg shadow-xl w-full" />
            </div>
          </div>
        </div>
      </div>

      {/* Join our Family Section */}
      <div className="py-16 px-6 md:px-12 lg:px-24">
        <div className="bg-primary text-white py-16 px-6 md:px-12 rounded-2xl">
          <div className="text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Join our Family</h2>
            <p className="text-white text-lg max-w-4xl mx-auto mb-8 font-sf-pro">
              Whether you're seeking healing, looking for a prophetic word, or simply want to grow in your faith, House of Praise is your spiritual home, come and experience the supernatural love and power of God in a welcoming, spirit-filled community.
            </p>
            <Link 
              to="/contact"
              className="bg-black text-white hover:bg-black font-medium py-3 px-8 rounded-md transition duration-300 font-sf-pro inline-flex items-center gap-2 group"
            >
              Contact us
              <FaArrowRight className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-200" />
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AboutUs;